import React from 'react';

const TrelloAttachmentIcon = (props) => (
  <svg width={1920} height={1920} viewBox="0 0 1920 1920" {...props}>
    <path
      d="M0 239.998C0 107.451 107.45 0 239.998 0h1440.004C1812.549 0 1920 107.45 1920 239.998v1440.004c0 132.547-107.45 239.998-239.998 239.998H239.998C107.451 1920 0 1812.55 0 1680.002V239.998zM240 360C240 293.726 293.724 240 360 240h360c66.274 0 120 53.728 120 120v1080c0 66.274-53.724 120-120 120H360c-66.274 0-120-53.728-120-120V360zM1200 240h360c66.274 0 120 53.717 120 120v691c0 66.275-53.724 120-120 120h-360c-66.274 0-120-53.717-120-120V360c0-66.275 53.724-120 120-120z"
      fill={props.color || 'currentColor'}
      fillRule="evenodd"
    />
  </svg>
);

export default TrelloAttachmentIcon;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/icons/TrelloAttachmentIcon.js